<template>
  <div class="container-fluid">
    <div v-if="tests.length > 1" class="row justify-content-center d-print-none">
      <div class="col">
        <div class="row">
          <div class="col text-center">
            <div class="btn-group btn-group-sm btn-group-toggle mb-3" data-toggle="buttons">
              <label
                class="btn btn-outline-primary"
                :class="{ active: selectedTest === test }"
                @click="selectedTest = test"
                v-for="test in tests"
                :key="test.testDisplayName"
              >
                <input type="radio" id="view-list" :value="test.testDisplayName" autocomplete="off" />
                <fa icon="clipboard" />
                {{ test.testDisplayName }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center d-none d-print-block">
      <div class="col">
        <h1>{{ selectedTest ? selectedTest.testDisplayName : "" }} Test Statistics</h1>
        <div class="card">
          <div class="card-body">
            <h2>Filters</h2>
            <dl class="row">
              <template v-for="filter in filters">
                <dt class="col-2" :key="filter.displayName + '-left'">{{ filter.displayName }}</dt>
                <dd class="col-4" :key="filter.displayName + '-right'">{{ filter.displayValue || "(All)" }}</dd>
              </template>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col">
        <div v-if="!isCompleted" class="alert alert-warning my-3" role="alert">
          <fa icon="exclamation-triangle" /> <span>Statistics are only available for <strong>completed</strong> reports.</span>
        </div>
        <StatisticsByTest v-if="isCompleted" :data="selectedTest" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "debounce";
import StatisticsByTest from "@/views/reports/report/statistics-reports/StatisticsByTest.vue";

export default {
  components: {
    StatisticsByTest,
  },
  props: {
    organizationId: String,
    query: String,
    status: Object,
    dateRange: Object,
    regionIds: Array,
    facilityIds: Array,
    companyIds: Array,
    functionIds: Array,
    countryIds: Array,
    stateIds: Array,
  },
  data() {
    return {
      isLoading: false,
      error: null,

      filters: [],
      tests: [],
      selectedTest: null,
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
    ...mapGetters("user", ["user"]),
    queryString() {
      let url = "";
      if (this.query) url += `&query=${encodeURIComponent(this.query)}`;
      if (this.status) url += `&status=${this.status.code}`;
      if (this.dateRange.start) url += `&startDate=${Math.floor(this.dateRange.start.getTime() / 1000)}`;
      if (this.dateRange.end) url += `&endDate=${Math.floor(this.dateRange.end.getTime() / 1000)}`;
      this.regionIds.forEach(id => (url += `&region=${id}`));
      this.facilityIds.forEach(id => (url += `&facility=${id}`));
      this.companyIds.forEach(id => (url += `&company=${id}`));
      this.functionIds.forEach(id => (url += `&function=${id}`));
      this.countryIds.forEach(id => (url += `&country=${id}`));
      this.stateIds.forEach(id => (url += `&state=${id}`));
      return url;
    },
    isCompleted() {
      return this.status && this.status.code === "completed";
    },
  },
  watch: {
    query() {
      this.load();
    },
    status() {
      this.load();
    },
    dateRange() {
      this.load();
    },
    regionIds() {
      this.load();
    },
    companyIds() {
      this.load();
    },
    facilityIds() {
      this.load();
    },
    functionIds() {
      this.load();
    },
    countryIds() {
      this.load();
    },
    stateIds() {
      this.load();
    },
    user() {
      this.skip = 0;
      this.load();
    },
    organization() {
      this.skip = 0;
      this.load();
    },
    organizationId() {
      this.skip = 0;
      this.load();
    },
  },
  created() {
    this.load = debounce(this.load, 350);
    this.load();
  },
  methods: {
    load() {
      this.data = {};
      this.error = null;
      this.isLoading = true;
      this.$axios
        .get(`/v1/organizations/${this.organizationId}/reports/statistics?${this.queryString}`)
        .then(res => this.initTests(res.data))
        .catch(err => (this.error = err))
        .finally(() => (this.isLoading = false));
    },
    initTests(res) {
      this.filters = res.filters;
      this.tests = res.tests;

      var selectedTestCode = this.selectedTest ? this.selectedTest.testCode : this.$route.query.test;
      this.selectedTest = this.tests.find(t => t.testCode === selectedTestCode);
      this.selectedTest = this.selectedTest || this.tests[0];
    },
  },
};
</script>
